import { render, staticRenderFns } from "./FeedBackDetails.vue?vue&type=template&id=48f37a4f&scoped=true&"
import script from "./FeedBackDetails.vue?vue&type=script&lang=js&"
export * from "./FeedBackDetails.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackDetails.vue?vue&type=style&index=0&id=48f37a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f37a4f",
  null
  
)

export default component.exports